import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { UserContext } from "App";
import { useLocation } from "react-router-dom";
import SearchBalanceEntriesReq from "../../../Classes/Models/Requests/Accounting/SearchBalanceEntriesReq";
import AccountingApi from "../../../Classes/API/AccountingApi";
import SearchBalancesBar from "./SearchBalancesBar";
import Swal from "sweetalert2";
import MDBox from "components/MDBox";
import { Card, CardHeader, CircularProgress, Box } from "@mui/material";
import Loader from "Loader";
import UserBalanceTable from "./UserBalanceTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const index = () => {
  const User = useContext(UserContext);
  const [SearchRequest, setSearchRequest] = useState(new SearchBalanceEntriesReq());
  const { state } = useLocation();
  const [Entries, setEntries] = useState({});

  const [IsLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (Object.keys(Entries).length > 0) {
      setIsLoaded(true);
    } else {
      setIsLoaded(false);
    }
  }, [Entries]);

  useEffect(() => {
    // debugger;
    if (!User?.userType) return;
    // debugger;
    GetUserBalanceEntries();
  }, [SearchRequest, User]);

  const ShowSearchBar = () => {
    if (
      User.userType == "Admin" ||
      User.userType == "AccountingEmployee" ||
      User.userType == "AppointmentEmployee"
    ) {
      return (
        <SearchBalancesBar
          setSearchRequest={setSearchRequest}
          GetUserBalanceEntries={GetUserBalanceEntries}
        />
      );
    }
  };

  const GetUserBalanceEntries = async () => {
    SearchRequest.pagingParams.pageSize = 5;
    console.log(SearchRequest);
    let res = await AccountingApi.SearchAllBalances(SearchRequest);
    console.log("res:", res);
    if (res.status === "Success" && res.data?.list) {
      const sortedList = [...res.data.list].sort((a, b) =>
        b.data === a.data || currentbalance === a.data ? 1 : -1
      );
      setEntries({ ...res.data, list: sortedList });
    } else {
      setEntries({});
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {ShowSearchBar()}

      {!IsLoaded ? (
        <Loader />
      ) : (
        <UserBalanceTable
          GetEntries={GetUserBalanceEntries}
          SearchRequest={SearchRequest}
          setSearchRequest={setSearchRequest}
          Entries={Entries}
        />
      )}
    </DashboardLayout>
  );
};

export default index;
